import { Link } from 'react-router-dom';
import styles from './SiteFooter.module.css';

type SiteFooterProps = {
  /** Render a top border (used on inner pages). */
  readonly bordered?: boolean;
};

export const SiteFooter = ({
  bordered = false,
}: SiteFooterProps): JSX.Element => {
  const className = bordered
    ? `${styles.footer} ${styles.bordered}`
    : styles.footer;

  return (
    <footer id="footer" className={className}>
      <div className={styles.footerInner}>
        <div className={styles.footerLinks}>
          <Link to="/privacy" className={styles.footerLink}>
            プライバシーポリシー
          </Link>
          <a href="mailto:lisong@cji.jp" className={styles.footerLink}>
            お問い合わせ
          </a>
        </div>
        <p className={styles.footerCopyright}>@CJI, All rights reserved.</p>
      </div>
    </footer>
  );
};
